"use client";
import React from "react";
import { motion } from "motion/react";
import './Neurocortex.css';

const dots = new Array(7).fill(0);

const PATH_D =
  "M268.5 587.9 c-132.8 -11.5 -243 -113.4 -264.4 -244.6 -13.4 -82.1 7.5 -163.6 58.9 -230.3 8.8 -11.3 35.1 -37.9 47 -47.4 53.2 -42.3 116.8 -64.6 184.6 -64.6 54.5 0 106.1 14.7 154.3 43.9 38.1 23.2 71.2 41.2 118.1 64.5 91.9 45.7 165.2 72.7 225.5 83.2 14.5 2.6 18.2 2.8 40.5 2.9 26.1 0 32.3 -0.6 56.5 -5.6 35.4 -7.2 78.2 -21.2 126.8 -41.5 60.4 -25.1 138.1 -64.6 197.7 -100.4 32.5 -19.5 55.8 -29.8 85.2 -37.5 92.5 -24.1 190.7 -2.1 263.8 59.3 33.6 28.2 62.2 66.2 80 106.7 26.3 59.5 32 127.4 16 190.4 -27.8 109.7 -116.4 194 -227 216.1 -22.1 4.4 -33.4 5.5 -58 5.5 -24.6 0 -35.9 -1.1 -58 -5.5 -36.9 -7.4 -63.7 -18.3 -104.5 -42.7 -121.7 -72.8 -251.9 -128.4 -334.7 -142.9 -20.7 -3.6 -52 -4.5 -71.9 -2 -69.6 8.8 -175.2 49.6 -292.9 113.4 -18.7 10.1 -53.8 30.2 -62.3 35.6 -51.3 32.8 -118.5 48.9 -181.2 43.5z";

const NeurocortexGraphic = () => (
  <div className="neurocortex-graphic">
    <div className="infinity-container">
      {/* Sol ikon - Brain/Head */}
      <div className="infinity-icon infinity-icon--left">
        <img src="/images/ikon3 1.png" alt="Brain Icon" />
      </div>
      
      {/* Infinity sembolü + path boyunca gezen ışık */}
      <div className="infinity-border-container">
        <div className="infinity-bg">
          <svg viewBox="0 0 1668 589" className="infinity-svg">
            <defs>
              {/* Glow için hafif blur */}
              <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur stdDeviation="6" result="b" />
                <feMerge>
                  <feMergeNode in="b" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
              {/* Beyaz → mavi parıltı */}
              <linearGradient id="edgeFade" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#ffffff" stopOpacity="1" />
                <stop offset="50%" stopColor="#ffffff" stopOpacity="0.85" />
                <stop offset="100%" stopColor="#3b82f6" stopOpacity="1" />
              </linearGradient>
            </defs>

            {/* İnce sabit hat (çok hafif) */}
            <path
              d={PATH_D}
              fill="none"
              stroke="rgba(255,255,255,0.08)"
              strokeWidth="8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            {/* Gezici parıltı segmenti */}
            <motion.path
              d={PATH_D}
              fill="none"
              stroke="url(#edgeFade)"
              strokeWidth="8"
              strokeLinecap="round"
              strokeLinejoin="round"
              pathLength={1}
              strokeDasharray="0.15 0.85"    // daha uzun segment, daha kısa boşluk
              animate={{ strokeDashoffset: [0, -1] }} // saat yönünde dolaş
              transition={{ duration: 6, ease: "linear", repeat: Infinity }}
              filter="url(#glow)"
            />
          </svg>
        </div>
      </div>
      
      {/* Sağ ikon - Chip */}
      <div className="infinity-icon infinity-icon--right">
        <img src="/images/chip.png" alt="Chip Icon" />
      </div>
      
      {/* Animasyonlu noktalar - ortada */}
      <div className="infinity-dots">
        {dots.map((_, i) => (
          <span key={i} className="infinity-dot" style={{ "--i": i }} />
        ))}
      </div>
    </div>
  </div>
);

export default NeurocortexGraphic; 